<template>
  <div class="page-container">
    <BirdsEyeDetailView
      v-if="plantId"
      :plantId="plantId"
      :alias="alias"
      :timezoneDataMap="timezoneDataMap"
      :accessLevel="Number(accessLevel)"
      :retailerId="retailerId"
      :dateAdded="dateAdded"
      :retailerName="retailerName"
    />
  </div>
</template>

<script>
import { apiRequest } from '@/services/apiService';
import { getDevModeState, getUserInfo } from '@/services/cookieService';
import BirdsEyeDetailView from './BirdsEyeDetailView.vue';

export default {
  name: 'BirdsEyeDetailPage',
  components: {
    BirdsEyeDetailView,
  },
  data() {
    return {
      plantId: 0,
      alias: '',
      retailerId: null,
      dateAdded: '',
      retailerName: '',
      accessLevel: 0,
      timezoneDataMap: {
        timezone_offset: 0,
        timezone_name: '',
      },
      subDataUrl: '/api/v1.1/data',
    };
  },
  created() {
    this.getQueryParams();
    this.loadAccessLevel();
    this.initSubDataUrl();
    this.getTimezoneData();
  },
  watch: {
    '$route.query': {
      handler() {
        this.getQueryParams();
        this.getTimezoneData();
      },
      deep: true,
    },
  },
  methods: {
    getQueryParams() {
      this.alias = this.$route.query.alias || '';
      this.plantId = Number(this.$route.query.plant_id) || 0;
      this.retailerId = this.$route.query.retailer_id ? Number(this.$route.query.retailer_id) : null;
      const dateQ = this.$route.query.date_added;
      this.dateAdded = Array.isArray(dateQ) ? (dateQ[0] ?? '') : (dateQ ?? '');
      const retailerNameQ = this.$route.query.retailer_name;
      this.retailerName = Array.isArray(retailerNameQ) ? (retailerNameQ[0] ?? '') : (retailerNameQ ?? '');
    },
    loadAccessLevel() {
      const cookieData = getUserInfo();
      if (cookieData) {
        this.accessLevel = cookieData.accessLevel;
      }
    },
    initSubDataUrl() {
      const devModeState = getDevModeState();
      if (devModeState.isDevMode !== undefined) {
        this.subDataUrl = devModeState.isDevMode ? '/dev-api/api/v1.1/data' : '/api/v1.1/data';
      }
    },
    async getTimezoneData() {
      if (!this.plantId) return;
      try {
        const bodyData = {
          plant_id: this.plantId,
        };
        const url = `${this.subDataUrl}/bridge/rx_data/plant/plant_info/get`;
        const response = await apiRequest('post', url, bodyData);

        this.timezoneDataMap = {
          timezone_offset: 0,
          timezone_name: '',
        };

        if (response.errorCode === 0 && response.data && response.data.length > 0) {
          this.timezoneDataMap.timezone_offset = Number(response.data[0]['timezone']);
          this.timezoneDataMap.timezone_name = response.data[0]['timezone_name'];
        }
      } catch (error) {
        console.error('Error fetching timezone data:', error);
      }
    },
  },
};
</script>

<style scoped>
.page-container {
  padding: 20px;
  position: relative;
}
</style>
